exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-doc[data-v-0928008a] {\n  background-color: #f3f1f6;\n  padding: 8px 15px;\n  border: 1px solid #eceeef;\n}\n.upload-doc p[data-v-0928008a] {\n  margin: 0;\n  line-height: 20px;\n  font-weight: 500;\n  letter-spacing: 0px;\n}\n", ""]);

// exports
